import React from 'react';
import { Layers } from 'lucide-react';
import type { Role } from '../../types/framework';
import { PICKS_PER_TYPE, questionnaireSize } from '../../utils/framework';
type DomainsStepProps = {
  role: Role;
};
export function DomainsStep({
  role
}: DomainsStepProps) {
  return <div className="space-y-6 animate-in fade-in duration-300" data-id="element-89" data-mp="26u1cyw6du7ly">
      <div data-id="element-90" data-mp="26utbaerd6jfx">
        <h2 className="text-xl font-semibold text-slate-900" data-id="element-91" data-mp="26w4d49191h4e">
          Competency Domains
        </h2>
        <p className="text-sm text-slate-500 mt-1" data-id="element-92" data-mp="1j6jkszj7h7ig">
          These domains are set by the role and are included automatically.
        </p>
      </div>

      <div className="flex items-start gap-3 bg-slate-50 border border-slate-200 rounded-lg px-4 py-3" data-id="element-93" data-mp="1t3o66x588yy7">
        <Layers className="h-4 w-4 text-slate-500 mt-0.5 shrink-0" data-id="element-94" data-mp="1o2ift5z1hnru" />
        <p className="text-sm text-slate-600" data-id="element-95" data-mp="34hjoufvcbpu6">
          <span className="font-medium text-slate-900" data-id="element-96" data-mp="34g8iq9efa5zw">{role.name}</span>{' '}
          covers {role.domains.length} competency domains. In the next step
          you'll choose {PICKS_PER_TYPE} Characteristic and {PICKS_PER_TYPE}{' '}
          Behaviour questions for each, giving{' '}
          <span className="font-medium text-slate-900" data-id="element-97" data-mp="1eqcir1gnwzo0">
            {questionnaireSize(role)} questions
          </span>{' '}
          in total.
        </p>
      </div>

      <ol className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-98" data-mp="1nsu7pnnpc6ep">
        {role.domains.map((domain, i) => <li key={domain.id} className="flex items-start p-3 border border-slate-200 rounded-lg bg-white" data-id="element-99" data-mp="r2uq73pkpxjz" data-mpi={i}>
            <span className="w-6 h-6 rounded-md bg-slate-100 text-slate-600 text-xs font-semibold flex items-center justify-center mr-3 shrink-0" data-id="element-100" data-mp="w1efne3dlrh3">
              {i + 1}
            </span>
            <span className="min-w-0" data-id="element-101" data-mp="14v17wu8dkclj">
              <span className="block text-sm font-medium text-slate-900" data-id="element-102" data-mp="8bk3yzusm8yf">
                {domain.name}
              </span>
              <span className="block text-xs text-slate-500 mt-0.5" data-id="element-103" data-mp="ccdn7fxaizkz">
                {domain.characteristic.length} Characteristic ·{' '}
                {domain.behaviour.length} Behaviour available
              </span>
            </span>
          </li>)}
      </ol>
    </div>;
}